module.exports = __webpack_public_path__ + "img/Gold Standard.6b4823ad.jpg";